import { applyPageMetadata } from "@/lib/page-metadata";
import { createFileRoute } from "@tanstack/react-router";
import { ServicesIndex } from "./services";
import { breadcrumbSchema, jsonLdScript, organizationSchema } from "@/lib/seo";
import { HUB_TITLE, HUB_DESCRIPTION, hubGroups, hubFaqs, hubCardPath, plainHubAnswer } from "@/data/services-hub";

export const Route = createFileRoute("/services/")({
  head: () => applyPageMetadata("/services", {
    meta: [
      { title: HUB_TITLE },
      { name: "description", content: HUB_DESCRIPTION },
      { property: "og:title", content: HUB_TITLE },
      { property: "og:description", content: HUB_DESCRIPTION },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:url", content: "https://pageonelawyers.com/services" },
    ],
    links: [{ rel: "canonical", href: "https://pageonelawyers.com/services" }],
    scripts: [
      jsonLdScript(organizationSchema()),
      jsonLdScript(breadcrumbSchema([
        { label: "Home", path: "/" },
        { label: "Services", path: "/services" },
      ])),
      jsonLdScript({ "@context": "https://schema.org", "@type": "CollectionPage", "@id": "https://pageonelawyers.com/services#collection", name: "Legal Marketing Services for Law Firms", description: HUB_DESCRIPTION, url: "https://pageonelawyers.com/services" }),
      jsonLdScript({ "@context": "https://schema.org", "@type": "ItemList", itemListElement: hubGroups.flatMap((group) => group.cards).map((card, index) => ({ "@type": "ListItem", position: index + 1, name: card.name, url: `https://pageonelawyers.com${hubCardPath(card)}` })) }),
      jsonLdScript({ "@context": "https://schema.org", "@type": "FAQPage", mainEntity: hubFaqs.map((faq) => ({ "@type": "Question", name: faq.q, acceptedAnswer: { "@type": "Answer", text: plainHubAnswer(faq.a) } })) }),
    ],
  }),
  component: ServicesIndex,
});